import { useState } from 'react'
import { useRecoilCallback, useRecoilValue } from 'recoil'
// import qs from 'qs'
import PreviewTools, {
  // Tab,
  Tabs,
  TabsDesktopOrMobile,
  TabShowDynamicContent
} from 'Components/PreviewTool'
import SelectRecipient from 'Components/PreviewTool/SelectRecipient'
import deviceSizes from 'Components/PreviewTool/support/deviceSizes'
import {
  searchRecipientsCallback,
  updatePreviewCallback
} from 'Pages/Campaign/recoil/callbacks/callbackEditBee'
import {
  filtersState,
  groupsState,
  previewLastSelected,
  previewState
} from 'Pages/Campaign/recoil/state/preview'
// import { notifyOpener } from 'Helpers/notifyParent'
// import { useLocation } from 'react-router-dom'
// import { campaignState } from 'Pages/Campaign/recoil/state/campaign'
// import { useIntl } from 'react-intl'

// const TabAllPreviews = ({ idMessage }) => {
//   const intl = useIntl()
//   const { idList } = useRecoilValue(previewState)
//   return (
//     <Tab
//       className='c-preview-tab--all-previews'
//       label={intl.formatMessage({
//         id: 'Load.PreviewViewer.AllPreviews'
//       })}
//       onClick={() => {
//         notifyOpener('setCurrentList', [
//           idList,
//           `messages_app_redirector.aspx?r=${encodeURIComponent(
//             `/messages/email/${idMessage}/previews`
//           )}`,
//           true
//         ])

//         window.opener && window.close()
//       }}
//     />
//   )
// }

// TabAllPreviews.propTypes = {
//   idMessage: PropTypes.string.isRequired
// }

const Preview = () => {
  const [deviceType, setDeviceType] = useState('desktop')
  const [sizeId, setSizeId] = useState(deviceSizes[0].id)
  const { lastEmails, lastFilters, lastGroups, previewReferenceRecipient } =
    useRecoilValue(previewLastSelected)
  const { options, optionGroups } = useRecoilValue(filtersState)
  const groups = useRecoilValue(groupsState)
  // const { EmailOptions } = useRecoilValue(campaignState)
  const searchRecipients = useRecoilCallback(searchRecipientsCallback, [
    previewReferenceRecipient
  ])
  // const { search } = useLocation()
  // const qsParams = qs.parse(
  //   search.startsWith('?') ? search.substring(1) : search
  // )
  // const crossLists = Boolean(parseInt(qsParams.crossLists))
  // const overviewNotSave = Boolean(parseInt(qsParams.ons))
  // const hideAllPreview = Boolean(parseInt(qsParams.hideAllPreview))

  // const hasAllPreviews = !(crossLists || hideAllPreview || overviewNotSave)

  const {
    html,
    showPersonalization,
    dynamicContents,
    loading,
    error,
    selectedDynamicContents
  } = useRecoilValue(previewState)

  const handleConfirmDynamicContents = useRecoilCallback(
    updatePreviewCallback,
    []
  )

  const size = deviceSizes.find((size) => size.id === sizeId)

  const TabsComponent = () => (
    <Tabs>
      <TabsDesktopOrMobile
        active={deviceType}
        onClickTab={(value) => setDeviceType(value)}
        onChangeSelect={(value) => setSizeId(value)}
        selectValue={sizeId}
        showMobile
      />
      {/* {hasAllPreviews && <TabAllPreviews idMessage={EmailOptions.IdMessage} />} */}
      {dynamicContents && dynamicContents.length > 0 && (
        <TabShowDynamicContent
          onConfirm={handleConfirmDynamicContents}
          items={dynamicContents}
          initialValues={selectedDynamicContents}
        />
      )}
    </Tabs>
  )

  return (
    <div className='t-message-edit__content'>
      <PreviewTools
        TabsComponent={TabsComponent}
        content={html}
        loading={loading}
        error={error}
        previewers={
          showPersonalization
            ? undefined
            : [
                {
                  sandbox:
                    'allow-same-origin allow-scripts allow-popups allow-popups-to-escape-sandbox',
                  content: html,
                  active: deviceType === 'desktop'
                },
                {
                  sandbox:
                    'allow-same-origin allow-scripts allow-popups allow-popups-to-escape-sandbox',
                  content: html,
                  width: size.width,
                  height: size.height,
                  pixelRatio: size.pixelRatio,
                  active: deviceType === 'mobile'
                }
              ]
        }
      >
        <div style={!showPersonalization ? { display: 'none' } : undefined}>
          <SelectRecipient
            groups={groups}
            filters={options}
            filterGroups={optionGroups}
            lastEmails={lastEmails}
            lastFilters={lastFilters}
            lastGroups={lastGroups}
            lastTypeSelected={previewReferenceRecipient.lastTypeSelected}
            searchRecipientsCallback={searchRecipients}
          />
        </div>
      </PreviewTools>
    </div>
  )
}

export default Preview
